export const AUTH_IGNORE_LOGOUT = 'app/AUTH_IGNORE_LOGOUT';
export const CSS_FAILURE = 'CSS_FAILURE';
export const PRESERVE_ROUTE = 'PRESERVE_ROUTE';
export const HAS_ATTEMPTED_LOGIN = 'HAS_ATTEMPTED_LOGIN';
export const CURRENT_PATH = 'CURRENT_PATH';
export const RECHECKIN_AFTER_CALL = 'RECHECKIN_AFTER_CALL ';
